<template>
    <Card class="border-1 landing-page-card md:col-span-1">
        <template #content>
            <h1 class="text-l font-bold text-white mb-2">Daily overview</h1>
            <DataTable :value="dailyStats" dataKey="_id" scrollable :scrollHeight="isMobile ? '35vh' : '45vh'"
                class="rounded-xl shadow-sm md:col-span-1" fluid>
                <Column 
                    field="_id" 
                    header="Date" 
                    :headerStyle="headerStyles"
                    :bodyStyle="{ width: '5rem', minWidth: '5rem' }"
                    frozen
                >
                    <template #body="{ data }">
                        <span>{{ formatDate(data._id) }}</span>
                    </template>
                </Column>
                <Column field="clicks" header="Clicks" :headerStyle="headerStyles" />
                <Column field="signups" header="Signups" :headerStyle="headerStyles" />
                <Column field="FTD" header="FTDs" :headerStyle="headerStyles" />
                <Column field="CPA" header="CPAs" :headerStyle="headerStyles" />
                <Column header="Income" :headerStyle="headerStyles">
                    <template #body="{ data }">
                        <div :class="{ 'income-cell': getMetricsCustomerTotal(data) > 0 }">
                            <p>{{ formatCurrency(getMetricsCustomerTotal(data)) }}</p>
                        </div>
                    </template>
                </Column>
            </DataTable>
        </template>
    </Card>
</template>

<script setup>
import EarningsService from '@/services/EarningsService';
import { shallowRef, onMounted } from 'vue';
import { formatCurrency } from '@/utils/currencies';
import { getMetricsCustomerTotal } from '@/utils/earnings';
import { headerStyles } from '@/global/headerStyles';

const props = defineProps({
    userId: {
        type: String,
        required: false
    },
    from: {
        type: Date,
        required: false
    },
    to: {
        type: Date,
        required: false
    },
    isMobile: {
        type: Boolean,
        required: true,
        default: false
    }
});

const dailyStats = shallowRef([]);

const formatDate = (dateString) => {
    // Get today and yesterday dates in MM-DD format
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    
    const todayFormatted = `${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    const yesterdayFormatted = `${(yesterday.getMonth() + 1).toString().padStart(2, '0')}-${yesterday.getDate().toString().padStart(2, '0')}`;
    
    // Compare with the date string
    if (dateString === todayFormatted) {
        return 'Today';
    } else if (dateString === yesterdayFormatted) {
        return 'Yesterday';
    } else {
        return dateString;
    }
};

const getDailyOverview = async () => {
    try {
        const response = await EarningsService.getUserDailyStats(props.userId, props.from, props.to);
        dailyStats.value = response.data;
    } catch (error) {
        console.error(error);
    }
}
onMounted(() => {
    getDailyOverview();
});

</script>

<style scoped></style>